document.addEventListener("DOMContentLoaded", () => {
    const isIX = document.querySelector(".page-template-ix");
    if (!isIX) return;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const cards = document.querySelectorAll(".sound-simulator__card");

    cards.forEach((card) => {
        const playBtn = card.querySelector(".card__play-button");
        const soundUntouched = card.querySelector(".soundUntouched");
        const soundProcessed = card.querySelector(".soundProcessed");

        if (isIOS) {
            soundUntouched.muted = false;
            soundProcessed.muted = true;
        } else {
            soundUntouched.volume = 1;
            soundProcessed.volume = 0;
        }

        playBtn.addEventListener("click", (e) => {
            card.dataset.ready = "true";

            if (playBtn.classList.contains("card__play-button--active")) {
                soundUntouched.pause();
                soundProcessed.pause();
            } else {
                stopAllSounds();
                soundProcessed.play();
                soundUntouched.play();
            }

            playBtn.classList.toggle("card__play-button--active");

            !card.classList.contains("play") && card.classList.add("play");
            card.classList.toggle("playing");
        });

        const effectBtns = card.querySelectorAll(".card__effect-js");
        let ready = false;

        effectBtns.forEach((button) => {
            button.addEventListener("click", (e) => {
                ready = card.dataset.ready === "true";
                effectBtns.forEach((button) => button.classList.remove("active"));
                e.target.classList.add("active");

                let loaded = false;

                const isEffectOnButton = e.target.classList.contains("card__effect-on");

                if (isEffectOnButton) {
                    if (isIOS) {
                        soundUntouched.muted = true;
                        soundProcessed.muted = false;

                        if (!loaded) {
                            soundProcessed.paused && soundProcessed.play();
                            loaded = true;
                        }
                    } else {
                        soundUntouched.volume = 0;
                        soundProcessed.volume = 1;
                    }
                } else {
                    if (isIOS) {
                        soundUntouched.muted = false;
                        soundProcessed.muted = true;

                        if (!loaded) {
                            soundUntouched.paused && soundUntouched.play();
                            loaded = true;
                        }
                    } else {
                        soundUntouched.volume = 1;
                        soundProcessed.volume = 0;
                    }
                }
            });
        });
    });

    const stopAllSounds = () => {
        document.querySelectorAll("audio").forEach((audio) => {
            audio.pause();
        });

        document.querySelectorAll(".card__play-button").forEach((playBtn) => {
            playBtn.classList.contains("card__play-button--active") && playBtn.classList.remove("card__play-button--active");
            const parentContainer = playBtn.closest(".sound-simulator__card");
            parentContainer.classList.remove("playing");
        });
    };

    const tabBtns = document.querySelectorAll(".tabs__button");
    const tabs = document.querySelector(".tabs__content").querySelectorAll(".sound-simulator__card");
    tabBtns.forEach((btn) => btn.addEventListener("click", changeTab));

    function changeTab() {
        tabBtns.forEach((btn) => btn.classList.remove("active"));
        this.classList.toggle("active");

        stopAllSounds();

        const selectedMode = this.dataset.mode;

        tabs.forEach((tab) => tab.classList.remove("active"));
        document.querySelector(`.sound-simulator__card--${selectedMode}`).classList.add("active");
    }
});
